import moment from "moment";
import "moment-timezone";
export class OrderOperationTransformer {
  static transform(obj) {
    let orderOperation                  = {}
    orderOperation.id                   = obj.id
    orderOperation.orderId              = obj.attributes.order_id
    orderOperation.operationId          = obj.attributes.operationId
    orderOperation.locationId           = obj.attributes.locationId
    orderOperation.equipmentId          = obj.attributes.equipmentId
    orderOperation.actualXCoordinate    = obj.attributes.actualXCoordinate
    orderOperation.actualYCoordinate    = obj.attributes.actualYCoordinate
    orderOperation.noAsset              = obj.attributes.noAsset
    orderOperation.status               = obj.attributes.status
    orderOperation.activitySubType      = obj.attributes.activitySubType
    orderOperation.ownerFirmId          = obj.attributes.owner_firm_id
    orderOperation.description          = obj.attributes.description
    orderOperation.requiredStart        = obj.attributes.requiredStart
    orderOperation.requiredFinish       = obj.attributes.requiredFinish
    orderOperation.actualStart          = obj.attributes.actualStart
    orderOperation.actualFinish         = obj.attributes.actualFinish
    orderOperation.firm_firm_id         = obj.attributes.firm_firm_id
    orderOperation.child_firm_person_id = obj.attributes.child_firm_person_id
    orderOperation.activity_code_id     = obj.attributes.activity_code_id
    orderOperation.repair_code_id       = obj.attributes.repair_code_id
    orderOperation.failure_code_id      = obj.attributes.failure_code_id
    orderOperation.outcome_code_id      = obj.attributes.outcome_code_id
    orderOperation.responsibility_code_id = obj.attributes.responsibility_code_id
    return orderOperation
  }
}




// WEBPACK FOOTER //
// ./src/helpers/orderOperations/orderOperation.transformer.js